import { render, staticRenderFns } from "./ImportExcelModal.vue?vue&type=template&id=654ce2be&scoped=true"
import script from "./ImportExcelModal.vue?vue&type=script&lang=js"
export * from "./ImportExcelModal.vue?vue&type=script&lang=js"
import style0 from "./ImportExcelModal.vue?vue&type=style&index=0&id=654ce2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ce2be",
  null
  
)

export default component.exports